import { render, staticRenderFns } from "./AppOrderSelect.vue?vue&type=template&id=521be05e&scoped=true"
import script from "./AppOrderSelect.vue?vue&type=script&lang=js"
export * from "./AppOrderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521be05e",
  null
  
)

export default component.exports